import React from 'react';
import { FUNDAMENTAL_RULE_TYPE } from '../../fundamentals/types';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

const PdpFundamentalRules = ({ rule }) => (
  <div className='mt8-sm'>
    <div className='body-2 u-bold'>
      <TranslatedCopy id='pdp.fundamental.minimum.title' />
    </div>
    <div className='body-3 text-color-secondary'>
      {rule ? (
        <TranslatedCopy id='pdp.fundamental.minimum.description' values={{ min: rule.minimumQuantity }} />
      ) : (
        <TranslatedCopy id='pdp.fundamental.required.description' />
      )}
    </div>
  </div>
);

PdpFundamentalRules.defaultProps = { rule: null };

PdpFundamentalRules.propTypes = { rule: FUNDAMENTAL_RULE_TYPE };

export default PdpFundamentalRules;
